import { Box, Paper } from '@mui/material';
import styled from 'styled-components';

export const StyledBox = styled(Box)`
  margin-bottom: 16px;
`;

export const StyledPaper = styled(Paper)`
  padding: 24px;
`;

export const StyledFlexWrapBox = styled(Box)`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 16px;
`;

export const StyledBox2 = styled(Box)`
  display: flex;
  align-items: center;
`;

export const StyledBox3 = styled(Box)`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 20px;
`;
export const StyledImage = styled.img`
  border-radius: 5px;
  min-width: 50px;
  maxwidth: 50px;
`;
